import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'
import { IConnectionWithTotal, IEdge, IEmployee, IPageInfo } from '@api/types'

interface IPayload {
  viewer: {
    company: {
      search: {
        employees: { edges: IEdge<IEmployee>[] }
      }
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, IConnectionWithTotal<IEmployee>>({
  handler: (data) => ({
    edges: data.viewer.company.search.employees.edges,
    pageInfo: {} as IPageInfo,
    counters: { total: 0 },
  }),
  name: 'Search Dept Admin User',
})

export default function searchDeptAdmin({
  query,
}: {
  query?: string
}): Promise<IConnectionWithTotal<IEmployee>> {
  return client.gql.query({ query: reportTo, variables: { query } }).then(mutateHandler)
}

const reportTo = gql`
  query reportTo($query: String!) {
    viewer {
      company {
        search(query: $query, type: employees) {
          employees(first: 20) {
            edges {
              node {
                id
                name
                email
                department {
                  id
                }
                team {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`
